import { createSlice } from '@reduxjs/toolkit';

const store = createSlice({
  name: 'videowall',
  initialState: {
    layoutType: 'fourParts',
    firstScreen: null,
    secondScreen: null,
    thirdScreen: null,
    fourthScreen: null,
  },
  reducers: {
    setScreen(state, { payload }) {
      return payload;
    },
  },
});

export default store.reducer;

export const {
  setScreen,
} = store.actions;
